<!-- TODO - this is a temporary solution, correct solution would be to create a general create account form that would read its configuration from assets/configuration/[cr|cwk]/configuration.ts -->
<form class="my-3 fix-row" #studentLoginForm="ngForm">

  <!-- ACCOUNT NAME -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="account" id="account" [ngClass]="{'cwk-form-control-invalid': (account.errors && account.errors['pattern']) || (errorSaving === 'DUPLICATE') || (student.Account && (student.Account.length < 8))}" [(ngModel)]="student.Account" (ngModelChange)="onAccountChange()" maxlength="32" minlength="8" #account="ngModel" pattern="^[A-Za-z0-9]+$" placeholder="Account Name">
      <label for="account" i18n>Account Name</label>
      <small class="ms-3 theme-error-color" *ngIf="student.Account && account.errors && account.errors['pattern']">Invalid value - only alphanumeric characters are allowed</small>
      <small class="ms-3 theme-error-color" *ngIf="student.Account && (student.Account?.length < 8) && !(account.errors && account.errors['pattern'])">Too short - at least 8 characters required</small>
      <small class="ms-3 theme-error-color" *ngIf="errorSaving === 'DUPLICATE'">The account with the same name already exists. Please choose another one.</small>
    </div>
  </div>

  <!-- PASSWORD -->
  <div class="col-12 col-md-6">
    <div class="form-floating mb-3">
      <input type="text" class="cwk-form-control form-control" name="secret" id="secret" [ngClass]="{'cwk-form-control-invalid': (secret.errors && secret.errors['pattern']) || (student.Secret && (student.Secret.length < 8))}" [(ngModel)]="student.Secret" maxlength="32" minlength="8" #secret="ngModel" pattern="^[\S\s]+$" placeholder="Secret">
      <label for="secret" i18n>Secret</label>
      <small class="ms-3 theme-error-color" *ngIf="student.Secret && secret.errors && secret.errors['pattern']">Invalid value - only printable characters are allowed</small>
      <small class="ms-3 theme-error-color" *ngIf="student.Secret && (student.Secret?.length < 8) && !(secret.errors && secret.errors['pattern'])">Too short - at least 8 characters required</small>
    </div>
  </div>

  <!-- BUTTONS -->
  <div class="col-12 d-grid d-sm-flex gap-3 justify-sm-content-between mt-4">

    <!-- CANCEL -->
    <button id="student-login-form-cancel" class="btn btn-warning me-5 w-100" (click)="cancel()" type="button">Cancel</button>

    <!-- SUBMIT -->
    <button id="student-login-form-submit" type="submit" class="btn btn-warning w-100" (click)="save()" [disabled]="isSaving || !studentLoginForm.valid">
      <span *ngIf="isSaving; else saveButton">
        <fa-icon class="me-1" [icon]="faSpinner" animation="spin"></fa-icon>Saving...
      </span>
      <ng-template #saveButton>Save</ng-template>
    </button>
  </div>
  <div class="mt-1 text-end theme-error-color" *ngIf="isInvalidSubmitted">
    <small>Required fields missing or invalid</small>
  </div>
</form>

<!-- ERROR CREATING ACCOUNT -->
<cwk-error-alert *ngIf="errorSaving && !['DUPLICATE'].includes(errorSaving)" [error]="errorSaving"></cwk-error-alert>
